var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingOfficePuzzleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dbe9fa;}.cls-2{fill:#52acf9;}.cls-3{fill:#d9dce1;}.cls-4{fill:#ffffff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "puzzle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,15v4.17a3,3,0,0,0,0,5.66V30H30V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2,2V17H9V16a1,1,0,0,1,2,0v1h6V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15,2V9h1a1,1,0,0,1,0,2H15v6h5.17a3,3,0,0,0,5.66,0H30V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,2H2V17H9V16a1,1,0,0,1,2,0v1h4v2.18a3,3,0,0,0,0,5.64V30H30V2ZM12.82,15a3,3,0,0,0-5.64,0H4V4H15V9h1a1,1,0,0,1,0,2H15v4ZM28,28H17V23H16a1,1,0,0,1,0-2h1V17h3.18a3,3,0,0,0,5.64,0H28ZM26,15H24v1a1,1,0,0,1-2,0V15H17V12.82a3,3,0,0,0,0-5.64V4H28V15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingOfficePuzzleSvgrepoCom);
export default __webpack_public_path__ + "static/media/marketing-office-puzzle-svgrepo-com.e4fe59ad16202d2d5e3a80d904187a65.svg";
export { ForwardRef as ReactComponent };